import { render, staticRenderFns } from "./BookingInfoAnimation.vue?vue&type=template&id=821ecaca&scoped=true&"
import script from "./BookingInfoAnimation.vue?vue&type=script&lang=js&"
export * from "./BookingInfoAnimation.vue?vue&type=script&lang=js&"
import style0 from "./BookingInfoAnimation.vue?vue&type=style&index=0&id=821ecaca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821ecaca",
  null
  
)

export default component.exports